
export const EVENT_ON_TAB_CLICK = 'onTabClick'



// WEBPACK FOOTER //
// ./src/core/components/mdTab/constants.js